import { render, staticRenderFns } from "./raise-incident.vue?vue&type=template&id=64c04a18&"
import script from "./raise-incident.vue?vue&type=script&lang=js&"
export * from "./raise-incident.vue?vue&type=script&lang=js&"
import style0 from "./raise-incident.vue?vue&type=style&index=0&id=64c04a18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports